import "../styles/Footer.css"

const Footer = () => {

    return (
        <div class="footer">
            @2023 | brickly.com | All rights reserved
        </div>

    )
}

export default Footer